var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchieveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2952 2.77116C4.46832 2.48915 4.77548 2.31728 5.1064 2.31728H18.1351C18.4784 2.31728 18.7951 2.50216 18.9639 2.80111L21.1892 6.74201C21.3086 6.95351 21.1558 7.21529 20.9129 7.21529H2.13414C1.88607 7.21529 1.73396 6.94343 1.86374 6.73202L4.2952 2.77116Z",
    stroke: "currentColor",
    strokeWidth: 0.634566
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23474 9.43637C1.23474 8.73545 1.80295 8.16724 2.50387 8.16724H11.5001H20.4963C21.1973 8.16724 21.7655 8.73545 21.7655 9.43637V20.323C21.7655 21.024 21.1973 21.5922 20.4963 21.5922H2.50388C1.80295 21.5922 1.23474 21.024 1.23474 20.323V9.43637ZM6.33799 13.0664C6.33799 12.6283 6.69312 12.2732 7.1312 12.2732H15.8688C16.3069 12.2732 16.662 12.6283 16.662 13.0664V13.5621C16.662 14.0002 16.3069 14.3553 15.8688 14.3553H7.1312C6.69312 14.3553 6.33799 14.0002 6.33799 13.5621V13.0664ZM7.1312 15.4263C6.69312 15.4263 6.33799 15.7814 6.33799 16.2195V16.7152C6.33799 17.1533 6.69312 17.5084 7.1312 17.5084H15.8688C16.3069 17.5084 16.662 17.1533 16.662 16.7152V16.2195C16.662 15.7814 16.3069 15.4263 15.8688 15.4263H7.1312Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.71936,
    y: 4.99414,
    width: 9.56145,
    height: 1.1898,
    rx: 0.237962,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7605,
    y: 3.30908,
    width: 7.49372,
    height: 1.1898,
    rx: 0.237962,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchieveicon);
export default __webpack_public_path__ + "static/media/archieve.icon.c5a1afb59ca6a3999336e802187d9955.svg";
export { ForwardRef as ReactComponent };